import { useAtom, useSetAtom } from 'jotai';
import { useCallback, useState } from 'react';

import { finCalcDataFieldValueAtom } from '../../Atoms/FinCalcDataFieldValue.atom';
import { BaseField } from '../../Entities/FinCalcFields.entity';
import { Slider } from '@gds/Slider/Slider';
import styles from './Range.module.css';

import { finCalcInteractedWithAtom } from '../../Atoms/FinCalcInteractedWith.atom';
import { isEmptyPayloadAtom } from '../../Atoms/isEmptyPayload.atom';

export const RangeInputElement = ({
  id,
  min,
  max,
  rangeLabel,
  currencySymbol,
  step,
}: BaseField) => {
  const [value, setValue] = useAtom(finCalcDataFieldValueAtom(id));
  const [currentValue, setCurrentValue] = useState(0);
  const [isChanging, setIsChanging] = useState(false);
  const [_, setIsEmpty] = useAtom(isEmptyPayloadAtom);

  const setFinCalcInteractedWith = useSetAtom(finCalcInteractedWithAtom);

  const handleOnAfterChange = useCallback(
    (values: [number, number]) => {
      setValue(values[0]);
      setIsChanging(false);
    },
    [value, setValue],
  );

  const handleOnChange = (e: [number, number]) => {
    setIsEmpty(false);
    setFinCalcInteractedWith(true);
    setIsChanging(true);
    setCurrentValue(e[0]);
  };

  const maxPrice = Math.ceil(max - min);

  return (
    <div className={styles.rangeContainer}>
      <div className={styles.wrapper}>
        <span className={styles.rangeLabel}>{rangeLabel}</span>
        {isChanging && (
          <div className={styles.currentValue}>
            {currencySymbol} {currentValue}
          </div>
        )}
      </div>
      <Slider
        isSingleKnob
        selectedRangeIndexes={[value]}
        onAfterChange={handleOnAfterChange}
        stepCount={maxPrice}
        step={step}
        onChange={handleOnChange}
      />
    </div>
  );
};
